/**
 * DraftRecoveryModal - 草稿恢复提示弹窗
 * 当检测到有未保存的草稿时，提示用户是否恢复
 */

import React from 'react';
import { formatSavedTime } from '../../services/draftService';
import { getGdsTheme } from '../../config/gdsThemes';
import './DraftRecoveryModal.css';

const DraftRecoveryModal = ({
  isOpen,
  draft,
  onRecover,
  onDiscard,
  onClose,
}) => {
  if (!isOpen || !draft) return null;

  const savedTimeText = formatSavedTime(draft.savedAt);
  const labelName = draft.data?.labelName || '未命名标签';
  const contentCount = draft.data?.contentItems?.length || 0;

  return (
    <div className="draft-recovery-overlay" onClick={onClose}>
      <div
        className="draft-recovery-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="draft-recovery-header">
          <div className="draft-recovery-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
              <path d="M3 3v5h5"/>
              <path d="M12 7v5l4 2"/>
            </svg>
          </div>
          <div className="draft-recovery-title">
            <h3>发现未保存的草稿</h3>
            <p className="draft-recovery-time">{savedTimeText}</p>
          </div>
        </div>

        {/* Content */}
        <div className="draft-recovery-content">
          <div className="draft-recovery-info">
            <div className="draft-info-row">
              <span className="draft-info-label">标签名称</span>
              <span className="draft-info-value">{labelName || '(未填写)'}</span>
            </div>
            <div className="draft-info-row">
              <span className="draft-info-label">内容模块</span>
              <span className="draft-info-value">{contentCount} 个</span>
            </div>
            {draft.data?.templateVariant && (
              <div className="draft-info-row">
                <span className="draft-info-label">模板类型</span>
                <span className="draft-info-value">
                  {draft.data.templateVariant === 'blue-white' ? '蓝白主题' :
                   draft.data.templateVariant === 'brown-v1' ? '棕色主题' :
                   (getGdsTheme(draft.data.templateVariant)?.name || '默认主题')}
                </span>
              </div>
            )}
          </div>

          <div className="draft-recovery-tip">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
            <span>您上次编辑的内容已自动保存，是否恢复？</span>
          </div>
        </div>

        {/* Actions */}
        <div className="draft-recovery-actions">
          <button
            className="draft-btn draft-btn-secondary"
            onClick={onDiscard}
          >
            放弃草稿
          </button>
          <button
            className="draft-btn draft-btn-primary"
            onClick={onRecover}
          >
            恢复编辑
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraftRecoveryModal;
